import { render, staticRenderFns } from "./Farmazon.vue?vue&type=template&id=4407b22e&"
import script from "./Farmazon.vue?vue&type=script&lang=js&"
export * from "./Farmazon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports